export default "__VITE_ASSET__CztEb31$__"